import React from "react";
import cn from "classnames";
import styles from "pages/StepPages/StepFive/SelectionCategories/SelectionCategories.module.sass";
import List from "pages/StepPages/StepFive/SelectionCategories/List";

const Wrapper = ({ categorizatedData }: any) => {

	return (
		<div>
			{categorizatedData.map((category: any, sectionIndex: any) => {
				return (
					<React.Fragment key={sectionIndex}>
						<div data-comment-false={true} className={cn(styles.sectionTitle, styles.trTitle)}>
							{category.title}
						</div>
						{category.listOfM.map((_: any) => (
							<List is key={_.stringId} row={_} sectionIndex={category.stringId} mIndex={_.stringId} />
						))}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default Wrapper;
